var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.48438 14.9525L15.1239 4.31299L20.6844 9.87499L10.0449 20.513L6.64438 18.3545L4.48438 14.9525Z",
    fill: "url(#paint0_linear_3367_292)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.94541 14.4919L4.48491 14.9524C3.92358 15.5138 3.5236 16.2158 3.32691 16.9849L2.02191 22.0624C1.98922 22.1889 1.99013 22.3217 2.02455 22.4477C2.05897 22.5737 2.12571 22.6886 2.21815 22.7809C2.31059 22.8732 2.42554 22.9397 2.55161 22.9739C2.67767 23.0081 2.81049 23.0088 2.93691 22.9759L8.01441 21.6709C8.78241 21.4759 9.48441 21.0739 10.0454 20.5129L10.5059 20.0524C10.5059 20.0524 8.57841 19.6024 6.98841 18.0109C5.39841 16.4194 4.94541 14.4919 4.94541 14.4919Z",
    fill: "url(#paint1_linear_3367_292)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2936 3.146C16.6587 2.78089 17.0922 2.49128 17.5692 2.29368C18.0463 2.09609 18.5575 1.99438 19.0739 1.99438C19.5902 1.99438 20.1015 2.09609 20.5785 2.29368C21.0556 2.49128 21.489 2.78089 21.8541 3.146C22.2192 3.51111 22.5089 3.94455 22.7065 4.42159C22.9041 4.89863 23.0058 5.40991 23.0058 5.92625C23.0058 6.44259 22.9041 6.95388 22.7065 7.43091C22.5089 7.90795 22.2192 8.34139 21.8541 8.7065L18.9921 11.5685L13.4316 6.008L16.2936 3.146Z",
    fill: "url(#paint2_linear_3367_292)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8984 6.5389C12.8984 6.5389 13.3409 8.4754 14.9324 10.0669C15.9156 11.0341 17.1294 11.7342 18.4589 12.1009L20.5994 9.9619C20.5994 9.9619 18.6644 9.5149 17.0744 7.9249C16.1064 6.94249 15.4053 5.72916 15.0374 4.3999L12.8984 6.5389Z",
    fill: "url(#paint3_linear_3367_292)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3367_292",
    x1: 13.4454,
    y1: 8.84449,
    x2: 15.9204,
    y2: 15.6425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB5937"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3367_292",
    x1: 0.779906,
    y1: 16.8619,
    x2: 6.9119,
    y2: 22.9579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#FFD394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF921F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3367_292",
    x1: 21.0036,
    y1: 3.986,
    x2: 17.4741,
    y2: 7.3055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F97DBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD3CE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3367_292",
    x1: 16.8809,
    y1: 9.6709,
    x2: 11.4419,
    y2: 7.2919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF921F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE994"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit_pencil.17d82580ac00f74983615cecf09be25c.svg";
export { ForwardRef as ReactComponent };